import { Offcanvas, Form, Button } from "react-bootstrap";
import Select from "react-select";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { REACT_SELECT_STYLES } from "configurations/Constants";
import {
  LABEL_SELECT_DATE_RANGE,
  LABEL_SELECT_RECIPE,
} from "configurations/MessageConstants";
import DateRangePicker from "components/common/DateRangePicker";

const RecipeUsageFilter = ({
  show,
  handleClose,
  selectedRecipes,
  dateRange,
  onApplyFilters,
  onResetFilters,
}) => {
  const [filterSelectedRecipes, setFilterSelectedRecipes] = useState([]);
  const [filterDateRange, setFilterDateRange] = useState({
    from: null,
    to: null,
  });
  const recipes = useSelector((state) => state.recipe.recipes);
  const RECIPES_OPTIONS = recipes?.map((recipe) => ({
    value: recipe.id,
    label:
      recipe.version > 1 ? `${recipe.name} (v${recipe.version})` : recipe.name,
  }));

  useEffect(() => {
    if (show) {
      setFilterSelectedRecipes(selectedRecipes);
      setFilterDateRange(dateRange);
    }
  }, [show, selectedRecipes, dateRange]);

  const handleClear = () => {
    setFilterSelectedRecipes([]);
    setFilterDateRange({ from: null, to: null });
  };

  const handleApply = () => {
    onApplyFilters({
      selectedRecipes: filterSelectedRecipes,
      dateRange: filterDateRange,
    });
    handleClose();
  };

  const handleReset = () => {
    const filterApplied = onResetFilters();
    if (!filterApplied) return;
    handleClear();
    handleClose();
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      aria-labelledby="recipe-usage-filter"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title
          id="recipe-usage-filter"
          className="w-100 d-flex align-items-center justify-content-between"
        >
          <span>Recipe Usage Filter</span>
          <Button
            variant="link"
            onClick={handleReset}
            className="filter-reset-button"
            aria-label="Reset Filters"
          >
            <span className="filter-reset-button-text">Reset</span>
            <i className="fa fa-refresh"></i>
          </Button>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-3">
          <Form.Label>Recipe</Form.Label>
          <Select
            isMulti
            value={filterSelectedRecipes}
            onChange={setFilterSelectedRecipes}
            options={RECIPES_OPTIONS}
            placeholder={LABEL_SELECT_RECIPE}
            styles={REACT_SELECT_STYLES}
            aria-label="Select Recipe"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <DateRangePicker
            label={LABEL_SELECT_DATE_RANGE}
            dateRange={filterDateRange}
            setDateRange={setFilterDateRange}
          />
        </Form.Group>

        <div className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" onClick={handleClear}>
            Clear
          </Button>
          <Button variant="primary" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default RecipeUsageFilter;
